export default __webpack_public_path__ + "static/SRC 4430 - Product Specifications & Technical Data-2ea4425a2daa874a8ad4abeeef387da5.pdf";